"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Clock = _interopRequireDefault(require("./Clock"));
var _ProductHit = _interopRequireDefault(require("./ProductHit"));
var _HitProvider = require("./provider/HitProvider");
var _HitImage = _interopRequireDefault(require("./HitImage"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkToHitPage = _interopRequireDefault(require("./LinkToHitPage"));
var _ProductsCounter = _interopRequireDefault(require("./ProductsCounter"));
var _Label = _interopRequireDefault(require("./Label"));
var _react = _interopRequireDefault(require("react"));
var __jsx = _react["default"].createElement;
var HitHomePage = function HitHomePage() {
  return __jsx(_HitProvider.HitProvider, null, __jsx(_LinkToHitPage["default"], null, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      flexDirection: ["column", null, null, "row"],
      py: ["s10", null, null, 0],
      // position: "relative",
      backgroundColor: "main" // bylo: "christmasRed"
      // backgroundImage: [
      //   `url("/static/images/hit_christmas_bg_mobile.jpg")`,
      //   null,
      //   null,
      //   `url("/static/images/hit_christmas_bg.jpg")`
      // ],
      // backgroundSize: "100% 100%"
    }
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: "50%",
      width: ["100%"],
      height: ["100%"],
      flex: "display",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center"
    }
  }, __jsx(_ProductHit["default"], null), __jsx(_Label["default"], {
    color: "blue" /* bylo: "red" */
  }), __jsx(_Clock["default"], {
    showLabel: true
  }), __jsx(_ProductsCounter["default"], {
    progressActive: false
  })), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      pt: [15, null, null, 25],
      flexBasis: "50%",
      width: "100%",
      maxHeight: ["auto", null, 400, 440],
      height: [200, 300, 400, 440],
      marginTop: ["s8", null, null, 0],
      justifyContent: ["center", null, null, "flex-start"]
    }
  }, __jsx(_HitImage["default"], {
    decreaseStyle: "white"
  })))));
};
var _default = HitHomePage;
exports["default"] = _default;